import { campaignConstants } from "../_constants";

export function campaigns(state = {}, action) {
    switch (action.type) {
        case campaignConstants.GETALL_REQUEST:
            return {
                loading: true
            };

        case campaignConstants.GETALL_SUCCESS:
            return {
                items: action.campaigns
            };

        case campaignConstants.GETALL_FAILURE:
            return {
                error: action.error
            };

        case campaignConstants.CAMPAIGNSIGNUP_REQUEST:
            return {};
            
        case campaignConstants.UPDATE_SUCCESS:
            if(!state.items){
                return {
                    items:action.campaigns,
                }
            }else if((action.campaigns["NOT_STARTED"] && !state.items["NOT_STARTED"])||(!action.campaigns["NOT_STARTED"] && state.items["NOT_STARTED"])  || (action.campaigns["NOT_STARTED"] && state.items["NOT_STARTED"] && action.campaigns["NOT_STARTED"][0].id !== state.items["NOT_STARTED"][0].id )){
                return {
                    items:{
                        ...state.items,
                        STARTED:action.campaigns["STARTED"]?action.campaigns["STARTED"]:[],
                        NOT_STARTED:action.campaigns["NOT_STARTED"]?action.campaigns["NOT_STARTED"]:[],
                    }
                }
           }else if((action.campaigns["FINISHED"] && !state.items["FINISHED"])|| (!action.campaigns["FINISHED"] && state.items["FINISHED"])|| (action.campaigns["FINISHED"] && state.items["FINISHED"] && action.campaigns["FINISHED"][0].id !== state.items["FINISHED"][0].id )){
                return {
                    items:{
                        FINISHED:action.campaigns["FINISHED"]?action.campaigns["FINISHED"]:[],
                        STARTED:action.campaigns["STARTED"]?action.campaigns["STARTED"]:[],
                        ...state.items,
                    }
                };
            }else {
                return {
                    items:{
                        ...state.items,
                        STARTED:action.campaigns["STARTED"]?action.campaigns["STARTED"]:[],
                    }
                }
            }
        case campaignConstants.DIALOG_OPEN:
            return {
                openDialog: true,
                item: action.campaign,
                userId: action.userId
            };

        case campaignConstants.DIALOG_CLOSE:
            return { reload: true };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/campaigns.reducer.js